import { moduleWorkflowNames } from "./moduleWorkflowNames";

export default {
  [moduleWorkflowNames.SET_DATA](state: any, payload: any) {
    state.commit(moduleWorkflowNames.SET_DATA, payload);
  },
  [moduleWorkflowNames.SET_DATA_COPY_JOURNEY](state: any, payload: any) {
    state.commit(moduleWorkflowNames.SET_DATA_COPY_JOURNEY, payload);
  },
  [moduleWorkflowNames.SET_WORKFLOW_TIP](state, payload: boolean) {
    state.commit(moduleWorkflowNames.SET_WORKFLOW_TIP, {
      id: state.rootGetters["user/user"]._id,
      close: payload,
    });
  },
};
